import { commonEnvironment } from './common.environment';

export const environment = {
  ...commonEnvironment,
  production: true,
  serverApiUrl: 'https://dp-api.walo.ch',
  shouldPollForUpdates: true,
  envName: 'prod',
  sentry: 'https://827a2e2ae8494f56b1d00997900dbe81@o296516.ingest.sentry.io/5799292',
  authServerUrl: 'https://dp-auth.walo.ch/auth',
  bearerExcludedUrls: ['https://dp.walo.ch'],
  applicationUrl: 'https://dp.walo.ch',
  citrixAuthUrl: 'https://dp-login.walo.ch',
};
